import { Icon } from './Icon'
import './MatchBar.css'

export interface SignalBreakdown {
  visual: number
  geo: number
  traits: number
  history: number
}

const SIGNAL_LABELS: Array<[keyof SignalBreakdown, string]> = [
  ['visual', 'Parecido'],
  ['geo', 'Zona'],
  ['traits', 'Señas'],
  ['history', 'Historial'],
]

/**
 * Renders the identity score alongside the four signals that produced it.
 * The score is a *coincidence* score, never presented as a calibrated
 * statistical probability, and the copy always hedges.
 */
export function MatchBar({
  score,
  signals,
  reasons,
  compact = false,
}: {
  score: number
  signals: SignalBreakdown
  reasons?: string[]
  compact?: boolean
}) {
  const weak = score < 0.6
  return (
    <div className="match">
      {!compact && (
        <div className="match__head">
          <span className="match__score-label">Coincidencia de identidad</span>
          <span className={'match__score' + (weak ? ' match__score--weak' : '')}>
            {Math.round(score * 100)}
            <small>%</small>
          </span>
        </div>
      )}
      <div className="match__signals" role="group" aria-label="Señales de coincidencia">
        {SIGNAL_LABELS.map(([key, label], i) => {
          const value = Math.max(0, Math.min(1, signals[key]))
          return (
            <div className="match__signal" key={key} data-weak={value < 0.35}>
              <div
                className="match__track"
                role="meter"
                aria-label={label}
                aria-valuenow={Math.round(value * 100)}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                <span
                  className="match__fill"
                  style={
                    {
                      '--fill': Math.round(value * 100) + '%',
                      '--delay': i * 70 + 'ms',
                    } as React.CSSProperties
                  }
                />
              </div>
              <span className="match__name">{label}</span>
            </div>
          )
        })}
      </div>
      {reasons && reasons.length > 0 && (
        <div className="match__reasons">
          {reasons.map((r) => (
            <span className="match__reason" key={r}>
              <Icon name="check" size={10} strokeWidth={2.2} />
              {r}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}
